import { Switch as SwitchMain } from './Switch';
export function createSwitch({ Root, }) {
    const Switch = SwitchMain(Root);
    Switch.displayName = 'Switch';
    return Switch;
}
